import en from "commonAssets/i18n/en";

en["exclusion_form_top_notice"] =
    "By submitting this form I am requesting exclusion from this Settlement, and I will not receive a Settlement payment.";
en["nav_submit_claim_button"] = "Fix Claim";

export default { en };
